import { isNil } from 'lodash';
import { DEFAULT_CALLOUT_PROPS } from '../../../../../Shape/config/Shapes';

const getTailLength = shape => (isNil(shape.get('tailLength')) ? DEFAULT_CALLOUT_PROPS.tailLength : shape.get('tailLength'));

export default getTailLength;
